import React, { useCallback, useEffect, useState } from 'react';
import './MemberDependant.scss';
import GlobalParams from '../../helpers/GlobalParams.js';
import Form, { Item, GroupItem, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import { LoadPanel } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import ApiHelper from '../../helpers/ApiHelper.js';

const isDateInRange = (date_from, date_to, check_date) => {
  return check_date >= date_from && check_date <= date_to;
}
const calculateAge = (birthDate) => {
  const currentDate = new Date();
  const birthDateObj = new Date(birthDate);

  let age = currentDate.getFullYear() - birthDateObj.getFullYear();

  // Check if the birthday has occurred for this year
  if (currentDate.getMonth() < birthDateObj.getMonth() ||
    (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
    age--;
  }

  return age;
};

function MemberDependant({ onClosePopup, SchemeID, MemberId }) {

  const [isLoading, setIsLoading] = useState(false);
  var default_form = {
    isNew: true,
    DependantEmail: '',
    DependantFullName: '',
    RelationshipType: null,
    DependantDOB: null,
    DependantAge: null,
    DependantJoiningDate: new Date()
  }
  const [dependantStore, setDependantStore] = useState(default_form);
  const clear_form = () => {
    setDependantStore(default_form);
  }

  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const doSave = useCallback(async (e) => {
    e.preventDefault();
    // Now you can submit the combined data to your backend or perform any other actions
    console.log('Submitted data:', dependantStore);

    clear_form();
    onClosePopup(dependantStore);
    //postDependant(claimStore);
  }, [dependantStore]);

  useEffect(() => {
    if (MemberId !== undefined) {
      setIsLoading(true);
      fetchDp();
    }
  }, [dependantStore]);

  const fetchDp = async () => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-dependants-on-member?member_id=" + MemberId,
        GlobalParams.bearerToken
      );
      setIsLoading(false);
      setDependantStore(result.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
      //notify(error.response.data.message,5000);
    }
  };

  return (
    <div className="App">

      {isLoading && <LoadPanel visible={true} />}
      <br />
      <form onSubmit={doSave}>
        <Form
          formData={dependantStore}>
          <GroupItem colCount={2} caption="">

            <Item
              dataField="DependantFullName"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setDependantStore((state) => {
                      return ({ ...state, DependantFullName: e.value })
                    });
                  }
                }
              }
            >
              <RequiredRule message="Full Names are Required" />
              <Label text='Full Names' />
            </Item>

            {/* DependantEmail */}
            {/* <Item
              dataField="DependantEmail"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      setDependantStore((state) => {
                        return ({ ...state, DependantEmail: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Email is required" />
              <Label text='Email' />
            </Item> */}

            <Item
              dataField="RelationshipType"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.RelationshipStore,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    setDependantStore((state) => {
                      return ({ ...state, RelationshipType: e.value })
                    });
                  }
                }
              }
            >
              <RequiredRule message="Relationship is Required" />
              <Label text='Relationship' />
            </Item>

            <Item
              dataField="DependantDOB"
              editorType="dxDateBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      const age = calculateAge(e.value);
                      var selectedDate = e.value;
                      var currentDate = new Date();

                      // Compare the selected date with the current date
                      if (selectedDate > currentDate) {
                        notify('Future Date of Birth is not allowed', 'error', 5000);
                        e.component.option("value", null); // Reset the value
                        return;
                      }
                      if (dependantStore.RelationshipType !== 'CH' && (age < 18 || age > 80)) {
                        // Clear the value if age is not within the range
                        e.component.option('value', null);
                        setDependantStore((state) => {
                          return ({ ...state, DependantAge: null })
                        });
                        // You can also provide feedback to the user that the value is invalid
                        notify('Age must be between 18 and 80 years old', 'error', 5000);
                      } else if (dependantStore.RelationshipType === 'CH' && age > 24) {
                        e.component.option('value', null);
                        setDependantStore((state) => {
                          return ({ ...state, DependantAge: null })
                        });
                        // You can also provide feedback to the user that the value is invalid
                        notify('Age must be between 0 and 24 years for Child', 'error', 5000);
                      } else {

                        setDependantStore((state) => {
                          return ({ ...state, DependantDOB: e.value })
                        });

                        setDependantStore((state) => {
                          return ({ ...state, DependantAge: age })
                        });
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule message="Date of Birth is required" />
              <Label text='Date of Birth' />
            </Item>

            <Item
              dataField="DependantAge"
              editorType="dxNumberBox"
              editorOptions={
                {
                  readOnly: true,
                  onValueChanged: (e) => {
                    setDependantStore((state) => {
                      return ({ ...state, DependantAge: e.value })
                    });
                  }
                }
              }
            >
              <RequiredRule message="Dependant Age is required" />
              <Label text='Age' />
            </Item>

            <Item
              dataField="DependantJoiningDate"
              editorType="dxDateBox"
              editorOptions={
                {
                  onValueChanged: (e) => {

                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //get the cover periods dates

                      const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === SchemeID);

                      // Assign the name to the variable 'ans'
                      const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                      const End_date = SchemeDetails ? SchemeDetails.End_date : null;

                      if (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value))) {
                        console.log(new Date(e.value));
                        setDependantStore((state) => {
                          return ({ ...state, DependantJoiningDate: new Date(e.value) })
                        });
                      } else {
                        // Clear the value if age is not within the range
                        e.component.option('value', null);
                        // You can also provide feedback to the user that the value is invalid
                        notify('Joining Date must be between the cover periods', 'error', 5000);
                      }
                    }

                  }
                }
              }
            >
              <RequiredRule message="Dependant Joining Date is required" />
              <Label text='Joining Date' />
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <ButtonItem
              colSpan={2}
            >
              <ButtonOptions type='default' text="ADD DEPENDANT" icon='save' useSubmitBehavior={true} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );
}
export default MemberDependant;
